var _linearGradient, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.056 -4.465 49.866 62.211",
    width: 49.866,
    height: 62.211,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 24.99,
    y1: 7.486,
    x2: 24.99,
    y2: 57.352,
    id: "gradient-1-1",
    xlinkHref: "#gradient-1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-1",
    "data-bx-pinned": "true"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "rgb(101, 21, 175)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    style: {
      stopColor: "rgb(193, 126, 255)"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-bx-fonts": "Amarante"
  }, "@import url(https://fonts.googleapis.com/css2?family=Amarante%3Aital%2Cwght%400%2C400&amp;display=swap);"))), /*#__PURE__*/React.createElement("rect", {
    x: 0.056,
    y: 0.058,
    width: 49.866,
    height: 49.866,
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 0,
      fill: "url(#gradient-1-1)"
    },
    rx: 7.1,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(255, 255, 255)",
      fontFamily: "Amarante",
      fontSize: "49.8px",
      whiteSpace: "pre"
    },
    transform: "matrix(0.824773, 0, 0, 1, 7.746064, -1.590662)",
    x: -5.419,
    y: 46.227
  }, "J'"), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(255, 255, 255)",
      fontFamily: "Amarante",
      fontSize: "36.3px",
      whiteSpace: "pre"
    },
    "data-bx-origin": "0.553 0.625",
    x: 28.145,
    y: 45.216
  }, "S"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.d8548b745cde2c234dc9e6e941782bb5.svg";
export { ForwardRef as ReactComponent };